
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 12.833a.917.917 0 01-.917-.917v-2.75a.917.917 0 111.834 0v2.75c0 .506-.41.917-.917.917zM9.625 15.125a1.375 1.375 0 112.75 0 1.375 1.375 0 01-2.75 0z","fill":"#F68E87"}}),_c('path',{attrs:{"d":"M9.378 2.947c.687-1.306 2.557-1.306 3.244 0l7.649 14.532a1.833 1.833 0 01-1.623 2.687H3.352a1.833 1.833 0 01-1.623-2.687L9.378 2.947zm9.27 15.386L11 3.8 3.352 18.333h15.296z","fill":"#F68E87"}})])
          )
        }
      }
    